import { FC, useEffect } from 'react';

import { getStaticPrefix } from '@eneco/common/env';
import useDC from '@eneco/dc/useDC';
import { I18nProvider, useTranslation } from '@eneco/i18n';
import { Skeleton } from '@eneco/sparky';
import { useTracking } from '@eneco/tracking';

import { useMeterReadingsFlow } from '../../../../state/MeterReadingsFlow.machine';
import { Steps } from '../../../../tracking';
import { Simple } from '../../../templates/Simple';

export const Registration: FC = () => {
  const { label } = useDC();

  return (
    <I18nProvider dictionary={locale => import(`./content/Registration.${label}.${locale}.json`)}>
      <RegistrationComponent />
    </I18nProvider>
  );
};

export const RegistrationComponent: FC = () => {
  const { label } = useDC();
  const { t, isLoading } = useTranslation();
  const { trackFunnelCompleted } = useTracking();
  const { state } = useMeterReadingsFlow();

  useEffect(() => {
    trackFunnelCompleted({
      step: Steps['THANK_YOU.Registration'],
      funnel: state.context.funnelName,
    });
  }, [state.context.funnelName, trackFunnelCompleted]);

  if (isLoading) return <Skeleton height={450} />;

  return (
    <Simple
      title={t('registration.title')}
      content={t('registration.content')}
      buttonHref={t('registration.buttonLink.href')}
      buttonText={t('registration.buttonLink.text')}
      nextStepList={[
        {
          label: t('registration.nextStep1'),
          state: 0,
        },
        {
          label: t('registration.nextStep2'),
          state: 0,
        },
        {
          label: t('registration.nextStep3'),
          state: 1,
        },
        {
          label: t('registration.nextStep4'),
          state: 1,
        },
      ]}
      heroImage={{
        value: {
          src: `${getStaticPrefix()}/images/${label}/meterreadings/${t('registration.imageSrc')}`,
        },
      }}
    />
  );
};
